// Show Product Links, if in Design Mode

if (window.Shopify.designMode) {
  const urls: Record<string, string> = {
    DNB: '/products/breed-ancestry',
    DNA: '/products/embark-dog-dna-test-kit',
    UPG: '/products/upg-101',
    BRD: '/products/embark-for-breeders-dog-dna-test-kit',
  };

  const links: HTMLDivElement = document.createElement('div');
  links.classList.add('theme-editor-links');
  Object.keys(urls).forEach((key) => {
    const url: string = urls[key];
    const link: HTMLAnchorElement = document.createElement('a');
    link.classList.add('theme-editor-links__link');
    link.setAttribute('href', url);
    link.innerText = `Product ${key}`;
    links.appendChild(link);
  });

  document.body.appendChild(links);
}
